import axios from "axios";

const BASE_URL = process.env.REACT_APP_BASE_API_URL;


export default axios.create({
  baseURL: BASE_URL,
  timeout: 60000000,
  headers: {
    "Accept": "application/json",
    "Content-Type": "application/json"
  }
});
